export const TRAINED_THRESHOLD = 50;

export const LEVEL_CLASSES = {
  trained: { badge: "bg-green-100 text-green-800", dot: "bg-green-500", text: "text-green-600" },
  in_progress: { badge: "bg-yellow-100 text-yellow-800", dot: "bg-yellow-500", text: "text-yellow-600" },
  not_started: { badge: "bg-red-100 text-red-800", dot: "bg-red-500", text: "text-red-600" },
  none: { badge: "", dot: "", text: "text-gray-500" },
};

export function completionLevel(percent) {
  if (percent === null || percent === undefined) return "none";
  if (percent >= TRAINED_THRESHOLD) return "trained";
  if (percent > 0) return "in_progress";
  return "not_started";
}

export function moduleField(moduleId) {
  return `module_${moduleId}`;
}

export function buildRows(stores, trainingModules) {
  return stores.map((store) => {
    const row = { id: store.id, name: store.name, cells: {} };
    trainingModules.forEach((trainingModule) => {
      const cell = store.modules[trainingModule.id] || null;
      row.cells[trainingModule.id] = cell;
      row[moduleField(trainingModule.id)] = cell?.percent ?? null;
    });
    return row;
  });
}

function compareNames(left, right) {
  return left.localeCompare(right, "fr", { sensitivity: "base" });
}

// Empty values (module not applicable) always go last, whatever the direction
export function sortRows(rows, field, direction) {
  const factor = direction === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const left = a[field];
    const right = b[field];
    if (left === right) return compareNames(a.name, b.name);
    if (left === null || left === undefined) return 1;
    if (right === null || right === undefined) return -1;
    if (typeof left === "string") return compareNames(left, right) * factor;
    return (left - right) * factor;
  });
}
